// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ebb8e5ae","455":"5a5ad331","977":"2ecd1217"}[chunkId] + ".chunk.js";
};